<template><div><h1 id="buchungen-einlesen" tabindex="-1"><a class="header-anchor" href="#buchungen-einlesen"><span>Buchungen einlesen</span></a></h1>
<p>Buchungen einlesen — Einlesejob für Gutschriften und Stornos</p>
<h2 id="beschreibung" tabindex="-1"><a class="header-anchor" href="#beschreibung"><span>Beschreibung</span></a></h2>
<p>Mit dieser Funktion wird der im <RouteLink to="/referenz/refs/ft.refdata.bucheinlprot.html" title="Buchungen einlesen">Protokoll</RouteLink> definierte Einleseprozess gestartet. Die Gutschriften werden anhand der Referenznummer der entsprechenden Person zugeordnet und verbucht. Zusammen mit den Gutschriften werden auch die Storni (Rückbuchungen) eingelesen.</p>
<h2 id="start-parameter" tabindex="-1"><a class="header-anchor" href="#start-parameter"><span>Start &amp; Parameter</span></a></h2>
<p>Pfad: Buchhaltung → Verarbeitungsläufe → Buchungen einlesen → Menü → Buchungen einlesen</p>
<p><strong>Parameter</strong></p>
<dl>
<dt>Job / Laufnummer</dt>
<dd>Datum und Laufnummer des Jobs.</dd>
<dt>Auf dem Protokoll ausdrucken</dt>
<dd>In den nachfolgenden Feldern kann festgelegt werden, wie detailliert das Protokll ausgegeben werden soll.</dd>
<dt>alle Buchungen</dt>
<dd>Gutschriften: Druckt alle Gutschriften.</dd>
<dt>Buchungen mit Abweichungen/Storni</dt>
<dd>Druckt sämtliche Gutschriften, die nicht zuordbar sind (Buchungen werden auf virtuelle Personen-ID 999'999 gebucht) sowie Doppelzahlungen, Widerrufe und Rückbuchungen.</dd>
<dt>Legende der Spaltenüberschriften</dt>
<dd>Druckt eine Legende.</dd>
</dl>
<h2 id="output-liste" tabindex="-1"><a class="header-anchor" href="#output-liste"><span>Output (Liste)</span></a></h2>
<p>Im Protokoll können folgende Möglichkeiten als &quot;Fehler&quot; erscheinen:</p>
<ul>
<li>
<p>Jemand bezahlt Ware mit einem Spendeneinzahlungsschein</p>
</li>
<li>
<p>Jemand bezahlt Ware doppelt (nach Mahnlauf häufig)</p>
</li>
<li>
<p>Das System bucht auf ein nicht existentes Ereignis (Lesefehler der Post)</p>
</li>
<li>
<p>Ein Rechnung-Einzahlungsschein wird für eine Spende verwendet</p>
</li>
<li>
<p>Eine Kundennummer stimmt nicht, kann nicht gelesen werden (Lesefehler der Post)</p>
</li>
<li>
<p>Ein ausgetretenes Mitglied wird bei LSV/DD durch die Zahlung wieder reaktiviert, etc.</p>
</li>
</ul>
<h2 id="welche-daten-werden-verwendet-input" tabindex="-1"><a class="header-anchor" href="#welche-daten-werden-verwendet-input"><span>Welche Daten werden verwendet? (Input)</span></a></h2>
<p>Daten aus dem Importfile und bestehende Buchungsdaten aus funtrade.</p>
<h2 id="welche-daten-werden-verandert-oder-erzeugt" tabindex="-1"><a class="header-anchor" href="#welche-daten-werden-verandert-oder-erzeugt"><span>Welche Daten werden verändert oder erzeugt?</span></a></h2>
<p>Die Gutschriften werden anhand der Referenznummer der entsprechenden Person zugeordnet und verbucht. Es werden Widerrufe und Storni gemäss den Festlegungen in den Tabellen <RouteLink to="/referenz/refs/ft.refdata.tbladrwiderruflsv.html" title="Widerrufe Parametrisierungen">Widerrufe LSV</RouteLink> und <RouteLink to="/referenz/refs/ft.refdata.tbladrwiderrufdd.html" title="pain.002-Parametrisierung">Widerrufe DD</RouteLink> bearbeitet.</p>
<h2 id="siehe-auch" tabindex="-1"><a class="header-anchor" href="#siehe-auch"><span>Siehe auch</span></a></h2>
<p><RouteLink to="/referenz/refs/ft.refdata.bucheinlprot.html" title="Buchungen einlesen">Protokoll Buchungen einlesen</RouteLink>, <RouteLink to="/referenz/refs/ft.refdata.tbladrwiderruflsv.html" title="Widerrufe Parametrisierungen">Widerrufe Parametrisierungen</RouteLink>, <RouteLink to="/referenz/refs/ft.refdata.tbladrwiderrufdd.html" title="pain.002-Parametrisierung">pain.002-Parametrisierung</RouteLink></p>
</div></template>


